import { Injectable } from '@angular/core';
import { AuthService } from 'app/services/auth.service';
import { environment } from 'environments/environment';

interface ViewerParams {
  token: string;
  customerId: string;
  businessId: string;
  locationId: string;
  locationName?: string;
}

@Injectable({ providedIn: 'root' })
export class FloorPlanViewerService {
  constructor(private authService: AuthService) {
  }

  openViewer = (customerId: string, locationId: string, locationName?: string) => {
    const params: ViewerParams = {
      token: this.authService.getToken(),
      customerId,
      businessId: this.authService.currentBusiness?.id,
      locationId,
      locationName,
    };

    const payload = btoa(JSON.stringify(params));
    const url = `${environment.mapViewerBaseUrl}?data=${payload}`;
    window.open(url, '_blank');
  };
}
